<template>
	<div class="jltd_page">
		<div class="tfm_right">
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">姓名</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.name" placeholder="请输入姓名" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">性别</span>：
					<div class="tm_tight flex3">
						<el-radio-group v-model="formData.gender">
							<el-radio :label="1">男</el-radio>
							<el-radio :label="2">女</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">出生年月</span>：
					<div class="tm_tight flex3">
						<el-date-picker :editable="false" v-model="formData.birthday" type="month" placeholder="请选择出生年月">
						</el-date-picker>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">民族</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.nationality" placeholder="请输入民族" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">籍贯</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.domicile" placeholder="请输入籍贯" maxlength="10"></el-input>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">婚姻状况</span>：
					<div class="tm_tight flex3">
						<el-radio-group v-model="formData.marriage">
							<el-radio :label="2">未婚</el-radio>
							<el-radio :label="1">已婚</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">政治面貌</span>：
					<div class="tm_tight flex3">
						<el-select v-model="formData.politics" placeholder="请选择">
							<el-option v-for="item in polarr" :key="item.value" :value="item.value">
							</el-option>
						</el-select>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">学历</span>：
					<div class="tm_tight flex3">
						<el-select v-model="formData.education" placeholder="请选择">
							<el-option v-for="item in eduarr" :key="item.value" :value="item.value">
							</el-option>
						</el-select>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">技术职称</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.zhicheng" placeholder="请输入技术职称" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">毕业院校</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.school" placeholder="请输入毕业院校" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">所学专业</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.major" placeholder="请输入所学专业" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">毕业院校</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.post" placeholder="请输入应聘岗位" maxlength="20"></el-input>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">期望年薪</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.salary" placeholder="请输入期望年薪" maxlength="10"></el-input>
						<span class="star">*</span>
					</div>
				</div>
				<div class="tm_sty1 flex3">
					<span class="tm_left">到岗时间</span>：
					<div class="tm_tight flex3">
						<el-date-picker :editable="false" v-model="formData.dutydate" type="date" placeholder="请选择到岗时间">
						</el-date-picker>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty1 flex3">
					<span class="tm_left">联系电话</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.phone" placeholder="请输入联系电话" maxlength="11"></el-input>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">家庭住址</span>：
					<div class="tm_tight flex3">
						<el-input v-model="formData.address" placeholder="请输入家庭住址" maxlength="50"></el-input>
						<span class="star">*</span>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">教育经历</span>：
					<div class="tm_tight flex3">
						<el-input type="textarea" :rows="4" v-model="formData.eduexp"></el-input>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">工作经历</span>：
					<div class="tm_tight flex3">
						<el-input type="textarea" :rows="4" v-model="formData.workexp"></el-input>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">项目经历</span>：
					<div class="tm_tight flex3">
						<el-input type="textarea" :rows="4" v-model="formData.proexp"></el-input>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">证书信息</span>：
					<div class="tm_tight flex3">
						<el-input type="textarea" :rows="4" v-model="formData.certificate"
							placeholder="(学历学位证、学信网学历证明、职称证书等)"></el-input>
					</div>
				</div>
			</div>
			<div class="tfm_item flex1">
				<div class="tm_sty2 flex3">
					<span class="tm_left">相关附件</span>：
					<el-upload class="upload_demo flex3" action="https://jsonplaceholder.typicode.com/posts/"
						:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3"
						:on-exceed="handleExceed" :file-list="fileList">
						<el-button icon="el-icon-upload2">选择文件</el-button>
						<span slot="tip" class="upload_tip">注：请将毕业证、学位证、学信网学历证明、职称证书、身份证等相关材料以.rar文件形式上传（文件大小10M以内）</span>
					</el-upload>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import contact from '@/components/contact.vue';
export default {
	components: { contact },
	data() {
		return {
			imgurl: require('@/images/banner.png'),
			formData: {
				name: '',
				gender: 1,
				birthday: '',
				nationality: '',//民族
				domicile: '',//籍贯
				marriage: 2,//婚姻状况
				politics: '',//政治面貌
				education: '',//学历
				zhicheng: '',
				school: '',
				major: '',//所学专业
				post: '',//应聘岗位
				salary: '',//年薪
				dutydate: '',//到岗时间
				phone: '',
				address: '',
				eduexp: '',//教育经历
				workexp: '',//教育经历
				proexp: '',//项目经历
				certificate: '',//证书信息
			},
			polarr: [{
				value: '中共党员',
			}, {
				value: '共青团员',
			}],
			eduarr: [{
				value: '本科',
			}, {
				value: '大专',
			}],
			tabtit: {
				title1: '党的建设',
				title2: 'Party Building',
			},
			tabact: 0,
			tabarr: [
				{
					title: '党建工作',
				},
				{
					title: '纪检监察',
				},
				{
					title: '群团工作',
				},
			]
		}
	},
	methods: {
		tabChange(index) {
			this.tabact = index;
		},
		selBirth() {
			// console.log(111)
		},
        handlePreview(){

        }
	}
}
</script>

<style lang="scss">
.jltd_page {
	.tm_left {
		width: 82px;
		color: #505b6d;
		font-size: 16px;
		text-align: justify;
		text-align-last: justify;
	}
	.star {
		margin-left: 15px;
		color: #c60002;
		width: 15px;
		text-align: right;
	}
	.tfm_right {
		.tfm_item {
			margin-bottom: 28px;
			padding-right: 45px;
			.tm_sty1 {
				width: 360px;
				.tm_tight {
					margin-left: 35px;
					width: 200px;
				}
			}
			.tm_sty2 {
				width: 100%;
				.tm_tight {
					margin-left: 35px;
					width: 85%;
				}
				.upload_demo {
					margin-left: 35px;
					width: 85%;
					.upload_tip {
						margin-left: 20px;
						color: #c5182b;
						font-size: 16px;
					}
				}
			}
		}
	}
}
</style>